import { render, staticRenderFns } from "./history-matrix.modal.vue?vue&type=template&id=24f2fb48&scoped=true"
import script from "./history-matrix.modal.vue?vue&type=script&lang=js"
export * from "./history-matrix.modal.vue?vue&type=script&lang=js"
import style0 from "./history-matrix.modal.vue?vue&type=style&index=0&id=24f2fb48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f2fb48",
  null
  
)

export default component.exports